import NinjaTable from 'components/tables/NinjaTable';
import React, { useMemo } from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import { AccountFormatter } from 'components/tables/NinjaTable/formatters/sourceFormatters';
import WidgetsCommonColumns from 'components/widgets/components/WidgetsCommonColumns';
import { useWidget } from 'components/Widget/useWidget';

const StatsByAdAccountTable = ({ height, widget_key }) => {
  const { dates } = useWidgetDate(widget_key);
  const { filters } = useWidget();

  const columns = useMemo(
    () => [
      {
        name: 'name',
        key: 'network_accounts.name',
        resizable: true,
        sortable: true,
        cellClass: 'stretch',
        minWidth: 250,
        frozen: true,
        renderCell: AccountFormatter,
        renderSummaryCell: () => {
          return 'Totals';
        },
      },
      ...WidgetsCommonColumns(),
    ],
    [dates, widget_key]
  );

  return (
    <NinjaTable
      columns={columns}
      dataProvider='networksTotalStatistics'
      queryParams={{ ...dates, ...filters }}
      disableFooter={true}
      cardProps={{ disable: true }}
      maxHeight={height}
      tableProps={{ template: 'widget' }}
    />
  );
};

export default StatsByAdAccountTable;
